import React, { useState } from "react";
import Link from "next/link";

import {
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
} from "@mui/material";
import DashIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import StoreIcon from "@mui/icons-material/StoreOutlined";
import CampaignIcon from "@mui/icons-material/CampaignOutlined";
import WorkIcon from "@mui/icons-material/WorkspacesOutlined";
import InboxIcon from "@mui/icons-material/InboxOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import ArrowIcon from "@mui/icons-material/ArrowForwardOutlined";

import { useRouter } from "next/router";
import SideNavContainer from "./SideNavContainer";

const links = [
  {
    href: "/",
    icon: <DashIcon />,
    label: "Dashboard",
  },
  {
    href: "/businesses",
    icon: <StoreIcon />,
    label: "Businesses",
  },
  {
    href: "/campaigns",
    icon: <CampaignIcon />,
    label: "Campaigns",
    divider: true,
  },
  {
    href: "/workshop",
    icon: <WorkIcon />,
    label: "Workshop",
  },
  {
    href: "/inbox",
    icon: <InboxIcon />,
    label: "Inbox",
  },
  {
    href: "/settings",
    icon: <SettingsIcon />,
    label: "Settings",
  },
];

export default function SideNav() {
  const [expand, setExpand] = useState(false);
  const { pathname } = useRouter();

  const isSelected = (href) => {
    return pathname === href;
  };

  return (
    <SideNavContainer expand={expand}>
      <List sx={{ flexGrow: 1 }}>
        {links.map((link) => (
          <React.Fragment key={link.href}>
            <Link href={link.href} passHref>
              <Tooltip key={link.href} title={link.label} placement="right">
                <ListItemButton selected={isSelected(link.href)}>
                  <ListItemIcon>{link.icon}</ListItemIcon>
                  <ListItemText>{link.label}</ListItemText>
                </ListItemButton>
              </Tooltip>
            </Link>
            {link.divider && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Toolbar sx={{ justifyContent: expand ? "end" : "center" }}>
        <IconButton onClick={() => setExpand(!expand)}>
          <ArrowIcon className={expand ? "rotate-180" : "rotate-0"} />
        </IconButton>
      </Toolbar>
    </SideNavContainer>
  );
}
